var previousPlacement = 0;

var initializeStaffBlock = function(block){

	var toggleSpeed = 400;
	var fourColumnMinBreakpoint = 1066
	var threeColumnMinBreakpoint = 791
	var mainDrawer = jQuery('.main-drawer', block);
	
	jQuery('.column .image', block).on('click', function(){
		
		var current = jQuery(this);
		var column = current.parents('.column');
		var parent = column.parent();
		var content = jQuery('.drawer-content', column).html();
		var windowSize = jQuery(window).width();
		var index = parent.children('.column').index(column) + 1;
		
		console.log(index);
		
		if(column.hasClass('open')) {
			
			console.log('just close');
			
			mainDrawer.slideUp(toggleSpeed);
			
			column.removeClass('open');
			
		} else {
			
			var currentColumnCount = 2;
			
			if(windowSize > fourColumnMinBreakpoint) {
				currentColumnCount = 4;
			} else if(windowSize > threeColumnMinBreakpoint) {
				currentColumnCount = 3;
			}
			
			var row = Math.ceil(index/currentColumnCount);
			var placement = row * currentColumnCount - 1;
			
			var anotherColumnOpen = jQuery('.column.open', block).length;
			
			if(anotherColumnOpen) {
				
				if(previousPlacement == placement) {
					
					console.log('Another column is open and placed in the same spot');
					
					jQuery('.content', mainDrawer).html(content);
					
					jQuery('.column.open', block).removeClass('open');
					
					column.addClass('open');
						
				} else {
					
					console.log('Another column is open but need to move drawer');
					
					mainDrawer.slideUp(toggleSpeed, function() {
						
						mainDrawer.insertAfter(jQuery('.column:eq(' + placement + ')', block));
													
						jQuery('.content', mainDrawer).html(content);
								
						mainDrawer.slideDown(toggleSpeed);
						
						column.addClass('open');
						
					});
					
				}
				
			} else {
				
				console.log('Just open - no other columns open');
				
				mainDrawer.insertAfter(jQuery('.column:eq(' + placement + ')', block));
							
				jQuery('.content', mainDrawer).html(content);
						
				mainDrawer.slideDown(toggleSpeed);
				
				column.addClass('open');
				
			}
			
			previousPlacement = placement;
			
		}
		
		
		
	});
	
	jQuery('.close', mainDrawer).on('click', function(){
		
		console.log('just close');
		
		mainDrawer.slideUp(toggleSpeed);
		
		jQuery('.column.open', block).removeClass('open');
	
	});

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-staff').each(function(){
		initializeStaffBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=staff', initializeStaffBlock);
